import classNames from "classnames";
import React, { useEffect } from "react";

import styles from "./index.module.css";

export const EnvMessage: React.FC<{
  isDev: boolean;
  isQA: boolean;
  isStg: boolean;
}> = ({ isDev, isQA, isStg }) => {
  const rootRef = React.useRef<HTMLDivElement>(null);
  const rootRectRef = React.useRef<DOMRect | null>(null);
  const [isHovering, setIsHovering] = React.useState(false);
  const isHoveringRef = React.useRef(isHovering);
  useEffect(() => {
    const updateRect = () => {
      if (rootRef.current) {
        rootRectRef.current = rootRef.current.getBoundingClientRect();
      }
    };
    const onMouseMove = (event: MouseEvent) => {
      if (!rootRectRef.current) return;

      const isHovering =
        rootRectRef.current.left <= event.clientX &&
        event.clientX <= rootRectRef.current.right &&
        rootRectRef.current.top <= event.clientY &&
        event.clientY <= rootRectRef.current.bottom;

      if (isHovering !== isHoveringRef.current) {
        isHoveringRef.current = isHovering;
        setIsHovering(isHovering);
      }
    };
    updateRect();
    window.addEventListener("resize", updateRect);
    window.addEventListener("mousemove", onMouseMove);
    return () => {
      window.removeEventListener("resize", updateRect);
      window.removeEventListener("mousemove", onMouseMove);
    };
  }, []);

  return (
    <div
      className={classNames(styles.envMessage, {
        [styles.stg]: isStg,
        [styles.qa]: isQA,
        [styles.isHovering]: isHovering,
      })}
      ref={rootRef}
    >
      <div style={{ fontSize: "40px" }}>
        {isDev ? "開発ビルド" : isQA ? "QAビルド" : "STAGINGビルド"}
      </div>
      <p>このコードを本番環境に入れないでください</p>
      <p>
        {process.env.WEBPACK_SERVE &&
          (isDev ? "serve_dev" : isQA ? "serve_qa" : "serve_stg")}
      </p>
      <p>{process.env.RELEASE_VERSION ?? ""}</p>
    </div>
  );
};
